import { render, staticRenderFns } from "./BFacebookSignIn.vue?vue&type=template&id=13276b0b&scoped=true"
import script from "./BFacebookSignIn.vue?vue&type=script&setup=true&lang=ts"
export * from "./BFacebookSignIn.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BFacebookSignIn.vue?vue&type=style&index=0&id=13276b0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13276b0b",
  null
  
)

export default component.exports